import { AILayout } from './components/AILayout';
import { AgentDashboardPage } from './agent-dashboard/agent-dashboard-page';
import { AgentDetailPage } from './agent-dashboard/agent-detail-page';
import { SkillsManager } from './skills/SkillsManager.jsx';
import { AILearningPage } from './ai-learning/ai-learning-page';
import { PoliciesLayout } from './policies/PoliciesLayout';
import { PoliciesList } from './policies/PoliciesList';
import { PolicyDetail } from './policies/PolicyDetail';

export const aiRoutes = {
  element: <AILayout />,
  children: [
    {
      index: true,
      element: <AgentDashboardPage />
    },
    {
      path: 'agents/:id',
      element: <AgentDetailPage />
    },
    {
      path: 'skills',
      element: <SkillsManager />
    },
    {
      path: 'policies',
      element: <PoliciesLayout />,
      children: [
        {
          index: true,
          element: <PoliciesList />
        },
        {
          path: ':id',
          element: <PolicyDetail />
        }
      ]
    },
    {
      path: 'learning',
      element: <AILearningPage />
    }
  ]
}; 